module.exports = __webpack_public_path__ + "img/arrow-route.9123c786.svg";